"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

require("./style.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var sizes = {
  xs: 8,
  sm: 16,
  md: 24,
  lg: 32
};

function TeamsMultitoneGreyFilled(_ref) {
  var className = _ref.className,
      inheritFontColor = _ref.inheritFontColor,
      inheritFontSize = _ref.inheritFontSize,
      size = _ref.size,
      width = _ref.width,
      height = _ref.height,
      disabled = _ref.disabled,
      onClick = _ref.onClick,
      muted = _ref.muted,
      clickable = _ref.clickable,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["className", "inheritFontColor", "inheritFontSize", "size", "width", "height", "disabled", "onClick", "muted", "clickable", "children"]);

  var classes = ['orion-icons-svg-base'];

  if (inheritFontColor) {
    classes.push('orion-icons-svg-current-clr');
  }

  if (muted) {
    classes.push('orion-icons-svg-muted');
  }

  if (!disabled && (clickable || typeof onClick === 'function')) {
    classes.push('orion-icons-svg-clickable');
  }

  if (disabled) {
    classes.push('orion-icons-svg-disabled');
  }

  classes.push(className);
  var finalWidth = width || sizes[size];
  var finalHeight = height || sizes[size];

  if (inheritFontSize) {
    finalWidth = finalHeight = '1em';
  }

  var finalClass = classes.filter(Boolean).join(' ');
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: finalWidth,
    height: finalHeight,
    fill: "none",
    viewBox: "0 0 16 16",
    color: "currentColor",
    className: finalClass,
    onClick: !disabled ? onClick : null
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "#C6C6C6",
    d: "M13.73 4.955a1.652 1.652 0 100-3.303 1.652 1.652 0 000 3.303z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6C757D",
    d: "M13.73 5.265a1.85 1.85 0 01-1.859-1.859 1.85 1.85 0 011.858-1.858 1.85 1.85 0 011.858 1.858 1.85 1.85 0 01-1.858 1.859zm0-3.304c-.723 0-1.343.62-1.343 1.342 0 .723.62 1.342 1.342 1.342.723 0 1.342-.62 1.342-1.342 0-.722-.516-1.342-1.342-1.342z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EAEAEA",
    d: "M8.774 4.955a2.374 2.374 0 100-4.749 2.374 2.374 0 000 4.749z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6C757D",
    d: "M8.774 5.265C7.33 5.265 6.09 4.129 6.09 2.58 6.09 1.135 7.33 0 8.774 0a2.556 2.556 0 012.58 2.58c0 1.549-1.238 2.685-2.58 2.685zm0-4.749A2.07 2.07 0 006.71 2.581a2.07 2.07 0 002.064 2.064 2.07 2.07 0 002.065-2.064A2.07 2.07 0 008.774.516z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EAEAEA",
    d: "M11.87 5.78H5.265c-.413 0-.619.31-.619.723v4.232c0 2.271 1.755 4.026 3.923 4.026 2.167 0 3.922-1.755 3.922-4.025V6.503c.103-.413-.206-.722-.62-.722z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6C757D",
    d: "M8.568 14.968c-2.374 0-4.233-1.962-4.233-4.336V6.4c0-.516.413-.93.93-.93h6.606c.516.001.929.517.929 1.033v4.232c0 2.271-1.961 4.233-4.232 4.233zm-3.304-8.98a.444.444 0 00-.412.412v4.232c0 2.065 1.651 3.82 3.716 3.82 2.064 0 3.716-1.652 3.716-3.82V6.503c0-.206-.207-.413-.413-.516v-.206.206H5.264z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#010101",
    d: "M8.155 4.232v.723c-.723-.207-1.342-.723-1.549-1.445h.93c.31 0 .619.31.619.722z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EAEAEA",
    d: "M.929 3.51h6.606c.31 0 .62.31.62.62v6.709c0 .413-.31.62-.62.722H.93c-.31 0-.62-.31-.62-.619v-6.71C.207 3.82.517 3.51.93 3.51z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6C757D",
    d: "M.929 11.768c-.206 0-.413-.104-.62-.31A.568.568 0 010 10.942v-6.71c0-.516.413-.929.929-.929h6.606c.517 0 .93.413.93.93v6.709c0 .516-.413.929-.93.929H.93v-.103zM.826 3.819c-.207 0-.31.207-.31.413v6.71c0 .103 0 .206.103.31.104.103.207.103.31.103h6.606a.444.444 0 00.413-.413v-6.71a.444.444 0 00-.413-.413H.825z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C6C6C6",
    d: "M11.045 5.78h4.026c.413 0 .723.31.723.723v3.716c0 1.446-1.136 2.581-2.478 2.581-1.342 0-2.477-1.136-2.477-2.58V6.09c-.103-.206 0-.31.206-.31z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6C757D",
    d: "M13.213 12.903a2.775 2.775 0 01-2.787-2.787V6.09c0-.31.31-.619.62-.619h4.025c.206 0 .516.103.62.31.206.206.309.413.309.619v3.716a2.775 2.775 0 01-2.787 2.787zm-2.168-6.916c-.103 0 0 0 0 0l-.103 4.13a2.291 2.291 0 002.27 2.27 2.291 2.291 0 002.272-2.27V6.4c0-.103 0-.206-.103-.31-.104-.103-.207-.103-.31-.103h-4.026zM5.987 6.09H4.645v3.613h-.929V6.09H2.477v-.722h3.51v.722z"
  }));
}

TeamsMultitoneGreyFilled.propTypes = {
  size: _propTypes["default"].string,
  width: _propTypes["default"].number,
  height: _propTypes["default"].number,
  className: _propTypes["default"].string,
  inheritFontColor: _propTypes["default"].bool,
  inheritFontSize: _propTypes["default"].bool,
  disabled: _propTypes["default"].bool,
  onClick: _propTypes["default"].func,
  clickable: _propTypes["default"].bool,
  muted: _propTypes["default"].bool
};
TeamsMultitoneGreyFilled.defaultProps = {
  size: 'sm',
  className: '',
  inheritFontColor: false,
  inheritFontSize: false,
  disabled: false,
  onClick: null,
  clickable: false,
  muted: true
};
var _default = TeamsMultitoneGreyFilled;
exports["default"] = _default;